module.exports = __webpack_public_path__ + "static/media/sun.3067658c.png";